import { Root } from '@radix-ui/react-dropdown-menu';

export const DropdownMenuRoot = Root;
